import { useHead, useSeoMeta } from "@unhead/react"
import Navbar from "@/components/Navbar"
import HeroSection from "@/components/HeroSection"
import GestationCalculator from "@/components/GestationCalculator"
import ToolsSection from "@/components/ToolsSection"
import GuideSection from "@/components/GuideSection"
import AboutSection from "@/components/AboutSection"
import QuickLinksFooter from "@/components/QuickLinksFooter"

function Home() {
  useSeoMeta({
    title: 'Cow Gestation Calculator | Free Cattle Due Date Tool',
    description: "Free cattle gestation calculator to find your cow's due date. Accurate for Holstein, Jersey, Highland & beef cattle. Plan your calving season.",
    ogType: 'website',
    ogTitle: 'Cow Gestation Calculator | Free Cattle Due Date Tool',
    ogDescription: "Find your cow's calving date instantly. Supports 10 breeds incl. Angus, Hereford & Holstein.",
    ogImage: 'https://www.cowcalculator.com/og-gestation.jpg',
    ogUrl: 'https://www.cowcalculator.com/',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Cow Gestation Calculator | Free Cattle Due Date Tool',
    twitterDescription: "Find your cow's calving date instantly across 10 cattle breeds.",
    twitterImage: 'https://www.cowcalculator.com/og-gestation.jpg',
  })

  useHead({
    link: [{ rel: 'canonical', href: 'https://www.cowcalculator.com/' }],
    script: [
      {
        type: 'application/ld+json',
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          "name": "Cow Gestation Calculator",
          "url": "https://www.cowcalculator.com/",
          "applicationCategory": "UtilitiesApplication",
          "operatingSystem": "Web",
          "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
          "description": "Free cattle gestation calculator to find a cow's calving date across 10 breeds."
        }),
      },
      {
        type: 'application/ld+json',
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [{
            "@type": "Question",
            "name": "How long is a cow's gestation period?",
            "acceptedAnswer": { "@type": "Answer", "text": "A cow's gestation period averages 283 days, varying by breed from roughly 279 to 287 days." }
          }]
        }),
      },
    ],
  })

  return (
    <div className="min-h-screen bg-[#FEFAE0]">
      <Navbar />
      <main>
        <HeroSection />
        <GestationCalculator />
        <ToolsSection />
        <GuideSection />
        <AboutSection />
      </main>
      <QuickLinksFooter />
    </div>
  )
}

export default Home
